"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lastPartnerMessageTimestamp = exports.hasSystemMessages = exports.hasPartnerOrTipMessages = exports.hasPartnerMessages = exports.hasMyMessages = exports.getUnreadMessages = exports.getMaxTimestampByRoomName = exports.getCurrentNotificationType = exports.getCurrentMessages = exports.getCurrentLastMessage = exports.alreadyLoadedMessages = void 0;
var _reselect = require("reselect");
var _partnerSelector = require("./partnerSelector");
var _chatSelector = require("./chatSelector");
var _messageUtil = require("../helpers/messageUtil");
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var _getCurrentMessages = function _getCurrentMessages(_ref) {
  var currentChat = _ref.currentChat,
    messagesByRoomName = _ref.messagesByRoomName;
  return messagesByRoomName[currentChat];
};
var _getCurrentMessage = (0, _reselect.createSelector)(_getCurrentMessages, function (_, idMessage) {
  return idMessage;
}, function (messages, idMessage) {
  return messages.find(function (msg) {
    return msg.id === idMessage;
  });
});
var getCurrentMessages = exports.getCurrentMessages = (0, _reselect.createSelector)(_getCurrentMessages, function (messages) {
  return messages || [];
});
var hasPartnerMessages = exports.hasPartnerMessages = (0, _reselect.createSelector)([_partnerSelector.getCurrentPartner, getCurrentMessages], function (_ref2, messages) {
  var partnerId = _ref2.id;
  return messages.some(function (msg) {
    return (0, _messageUtil.isMessageFromUser)(msg) && msg.sender === partnerId;
  });
});
var hasPartnerOrTipMessages = exports.hasPartnerOrTipMessages = (0, _reselect.createSelector)([getCurrentMessages], function (messages) {
  return messages.filter(function (msg) {
    return msg.idMessage !== 'security_message';
  }).length > 0;
});
var getMaxTimestampByRoomName = exports.getMaxTimestampByRoomName = function getMaxTimestampByRoomName(_ref3, roomname) {
  var messagesByRoomName = _ref3.messagesByRoomName;
  if (!messagesByRoomName[roomname]) {
    return undefined;
  }
  return messagesByRoomName[roomname].reduce(function (maxTimestamp, message) {
    var originalTimestamp = message.originalTimestamp;
    if (maxTimestamp === undefined || originalTimestamp > maxTimestamp) {
      return originalTimestamp;
    } else {
      return maxTimestamp;
    }
  }, undefined);
};
var alreadyLoadedMessages = exports.alreadyLoadedMessages = (0, _reselect.createSelector)(_chatSelector.getCurrentChat, function (_ref4) {
  var messagesLoaded = _ref4.messagesLoaded;
  return !!messagesLoaded;
});
var hasMyMessages = exports.hasMyMessages = (0, _reselect.createSelector)([_chatSelector.getCurrentChat, getCurrentMessages], function (_ref5, messages) {
  var myId = _ref5.username;
  return messages.some(function (msg) {
    return (0, _messageUtil.isMessageFromUser)(msg) && msg.sender === myId;
  });
});
var hasSystemMessages = exports.hasSystemMessages = (0, _reselect.createSelector)(getCurrentMessages, function (messages) {
  return messages.some(_messageUtil.isSystemMessage);
});
var getUnreadMessages = exports.getUnreadMessages = (0, _reselect.createSelector)([_chatSelector.getCurrentChat, getCurrentMessages], function (_ref6, messages) {
  var myId = _ref6.username;
  return messages.filter(function (msg) {
    return (0, _messageUtil.isMessageFromUser)(msg) && msg.sender !== myId && msg.status !== 'read';
  });
});
var lastPartnerMessageTimestamp = exports.lastPartnerMessageTimestamp = (0, _reselect.createSelector)([_chatSelector.getCurrentChat, getCurrentMessages], function (_ref7, messages) {
  var myId = _ref7.username;
  return Math.max.apply(Math, _toConsumableArray(messages.filter(function (msg) {
    return (0, _messageUtil.isMessageFromUser)(msg) && msg.sender !== myId;
  }).map(function (message) {
    return message.timestamp;
  })));
});
var getCurrentLastMessage = exports.getCurrentLastMessage = (0, _reselect.createSelector)([getCurrentMessages], function (messages) {
  return (0, _messageUtil.lastMessageFromUser)(messages);
});
var getCurrentNotificationType = exports.getCurrentNotificationType = (0, _reselect.createSelector)([_getCurrentMessage], function (_ref8) {
  var notificationType = _ref8.notificationType;
  return notificationType;
});